import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { FlexboxGrid } from 'rsuite';
import { LPDisplay } from '../../../../handlers/lpDisplays/LPDisplay';
import { VirtualDisplayStep } from '../../../../handlers/lpDisplays/VirtualDisplayStep';
import { RenderLPDisplayIcon } from '../Icons/RenderLPDisplayIcon';

type Props = {
    step: VirtualDisplayStep;
    backgroundColor: string;
    display: LPDisplay;
};

export const LPMatrixDisplayWidget = ({ step, backgroundColor, display }: Props) => {
    const stepMode = step.getMode();

    const shouldShowArrow =
        (stepMode === 1 ||
            (stepMode >= 201 && stepMode <= 232) ||
            (stepMode >= 301 && stepMode <= 316) ||
            (stepMode >= 101 && stepMode <= 132)) &&
        step.getShouldDisplayArrow();

    const shouldShowPicto =
        (stepMode === 2 ||
            (stepMode >= 201 && stepMode <= 232) ||
            (stepMode >= 301 && stepMode <= 316) ||
            (stepMode >= 101 && stepMode <= 132)) &&
        step.getShouldDisplayPicto();

    let text = '';

    if (stepMode === 5) text = moment().format('HH:mm:ss');
    if (stepMode === 6) text = moment().format('DD/MM/YYYY');
    if (stepMode === 7) text = moment().format('DD/MM/YYYY HH:mm:ss');

    if (stepMode === 20 && step.getPicto() !== 0) text = `Picto RGB ${step.getPicto()}`;

    if (stepMode >= 201 && stepMode <= 232) {
        let systemTextNumber = stepMode - 201;

        text = display.getTextConfig().getSystemTextEntries()[systemTextNumber].lang0;
    }

    if (stepMode >= 301 && stepMode <= 316) {
        let userTextNumber = stepMode - 301;

        text = display.getTextConfig().getUserText()[userTextNumber];
    }

    if (stepMode >= 101 && stepMode <= 132) text = `C-${step.getCounterNumber()}`;

    const shouldDisplayLeftPart =
        (shouldShowArrow && step.getArrowPosition() !== 'right') ||
        (shouldShowPicto && step.getPictoPosition() !== 'right');

    let justifyContent: any = 'space-around';

    if (stepMode === 1) {
        if (step.getArrowPosition() === 'right') {
            justifyContent = 'end';
        }

        // if (step.getArrowPosition() === 'center' || step.getPictoPosition() === 'center') {
        //     justifyContent = 'space-around';
        // }

        if (step.getArrowPosition() === 'left') {
            justifyContent = 'start';
        }
    }

    if (stepMode === 2 || stepMode === 20) {
        if (step.getPictoPosition() === 'right') {
            justifyContent = 'end';
        }

        if (step.getPictoPosition() === 'left') {
            justifyContent = 'start';
        }
    }

    if (stepMode === 5 || stepMode === 6 || stepMode === 7) {
        justifyContent = 'space-around';
    }

    if (stepMode >= 101 && stepMode <= 132) {
        if (shouldShowArrow && shouldShowPicto) {
            justifyContent = 'space-around';
        }
    }

    return (
        <div className="matrix-display-demo" style={{ backgroundColor }}>
            <FlexboxGrid align="middle" justify={justifyContent}>
                {shouldDisplayLeftPart && (
                    <FlexboxGrid>
                        {shouldShowArrow && step.getArrowPosition() !== 'right' && (
                            <FlexboxGrid.Item style={{ overflow: 'hidden' }}>
                                <FontAwesomeIcon
                                    data-cy="lpDisplay-virtualDisplay-step-arrow"
                                    icon={faArrowUp}
                                    color={step.getColorHex()}
                                    transform={{ rotate: step.getArrowRotation() }}
                                    size="2x"
                                    className={step.getArrowAnimation()}
                                />
                            </FlexboxGrid.Item>
                        )}

                        {shouldShowPicto && step.getPictoPosition() !== 'right' && (
                            <FlexboxGrid.Item data-cy="lpDisplay-virtualDisplay-step-picto">
                                <RenderLPDisplayIcon color={step.getColorHex()} icon={step.getPictoImage()} />
                            </FlexboxGrid.Item>
                        )}
                    </FlexboxGrid>
                )}

                {text && (
                    <FlexboxGrid.Item
                        data-cy="lpDisplay-virtualDisplay-displayMatrix"
                        className="matrix-display-demo-text"
                        style={{ color: step.getMode() === 20 ? 'white' : step.getColorHex() }}>
                        {text}
                    </FlexboxGrid.Item>
                )}

                {stepMode === 1 && step.getArrowRepeat() && (
                    <FlexboxGrid.Item style={{ overflow: 'hidden' }}>
                        <FontAwesomeIcon
                            icon={faArrowUp}
                            color={step.getColorHex()}
                            transform={{ rotate: step.getArrowRotation() }}
                            size="2x"
                            className={step.getArrowAnimation()}
                        />
                    </FlexboxGrid.Item>
                )}

                {shouldShowPicto && step.getPictoPosition() === 'right' && (
                    <FlexboxGrid.Item>
                        <RenderLPDisplayIcon color={step.getColorHex()} icon={step.getPictoImage()} />
                    </FlexboxGrid.Item>
                )}

                {shouldShowArrow && step.getArrowPosition() === 'right' && (
                    <FlexboxGrid.Item style={{ overflow: 'hidden' }}>
                        <FontAwesomeIcon
                            icon={faArrowUp}
                            color={step.getColorHex()}
                            transform={{ rotate: step.getArrowRotation() }}
                            size="2x"
                            className={step.getArrowAnimation()}
                        />
                    </FlexboxGrid.Item>
                )}
                {/* 
                {((shouldShowPicto && step.getPictoPosition() === 'right') ||
                    (shouldShowArrow && step.getArrowPosition() === 'right')) && (
                    <FlexboxGrid.Item style={{ overflow: 'hidden' }}>
                        {shouldShowPicto && step.getPictoPosition() === 'right' && (
                            <RenderLPDisplayIcon isMap color={step.getColorHex()} icon={step.getPictoImage()} />
                        )}

                        {shouldShowArrow && step.getArrowPosition() === 'right' && (
                            <FontAwesomeIcon
                                data-cy="lpDisplay-picto"
                                icon={faArrowUp}
                                color={step.getColorHex()}
                                transform={{ rotate: step.getArrowRotation() }}
                                size="lg"
                                className={step.getArrowAnimation()}
                            />
                        )}
                    </FlexboxGrid.Item>
                )} */}
            </FlexboxGrid>
        </div>
    );
};
